import { useFilterPackageAccommodationContext } from "./filter-package-accommodation.context";

export function FilterPackageAccommodation() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterPackageAccommodationContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}